import { Transaction } from '@/domain/transactions'

// Helper function to capitalize first letter (like in RN version)
const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getTransactionHeaderTitle = (
  transaction: Transaction,
  t: (key: string) => string,
): string => {
  const isSend = transaction.direction === 'send'

  switch (transaction.type) {
    case 'card_write_off':
      return capitalizeFirstLetter(t('translation:purchase'))

    case 'boxo_purchase':
      // Handle boxo purchase types based on order type
      if (transaction.subject_boxo_purchase?.boxo_order_type === 'esim') {
        return t('transactions:types.esimPurchase')
      }
      if (transaction.subject_boxo_purchase?.boxo_order_type === 'hotel') {
        return t('transactions:types.hotelPurchase')
      }
      if (transaction.subject_boxo_purchase?.boxo_order_type === 'flight') {
        return t('transactions:types.flightPurchase')
      }
      return capitalizeFirstLetter(t('translation:purchase'))

    case 'on_ramp_top_up':
      return t('translation:bought')

    case 'external_withdraw':
      return capitalizeFirstLetter(t('translation:withdrawn'))

    case 'swap_sell':
      return t('translation:sold')

    case 'swap_convert':
      // For conversions, show "Converted to [target currency]" like in RN
      if (transaction.subject_swap?.credit_amount?.currency) {
        const targetCurrency = transaction.subject_swap.credit_amount.currency
        return `${t('translation:convertedTo')} ${targetCurrency}`
      }
      return t('translation:converted')

    case 'external_deposit':
      return capitalizeFirstLetter(t('translation:deposit'))

    case 'kem_to_kem':
    case 'on_ramp_send':
      return capitalizeFirstLetter(
        isSend ? t('translation:sentTo') : t('translation:receivedFrom'),
      )

    case 'saving_transfer_in':
      return t('translation:goal.savingsDeposit')

    case 'saving_transfer_out':
      return t('translation:goal.savingsWithdrawal')

    case 'kem_reward':
      return t('translation:reward')

    case 'cashback_payout':
      return t('translation:cashbackPayout')

    default:
      return t('translation:details')
  }
}
